// Deal Profile views — list and editor surfaces (Phase 5C).
//
// Profiles are per-user reusable underwriting theses. They live on the
// Deal Calc surface (under `/deals/profiles/`) because they're a Deal
// Calc concept; the page chrome reuses the same `lb-redesign-body`
// background as the rest of Deal Calc.

export function init(..._args: Array<string>): void {
	// Apply the redesign body bg uniformly across all Deal Profile
	// pages — mirrors the dealcalc init pattern.
	document.body.classList.add('lb-redesign-body');
	if (document.getElementById('id_lb-deal-profile-onboarding')) {
		import('./onboarding')
			.then(mod => (new mod.DealProfileOnboardingView()));
		return;
	}
	if (document.getElementById('id_lb-deal-profile-editor')) {
		import('./view')
			.then(mod => (new mod.DealProfileEditorView()));
		return;
	}
	if (document.getElementById('id_lb-deal-profile-list')) {
		import('./view')
			.then(mod => (new mod.DealProfileListView()));
	}
}
